import { stableStringify } from "@sail/utils";
import { generateHashForDocument } from "./documentHashing";
export function buildQueryAndVariablesHash(document, variables) {
    const documentHash = generateHashForDocument(document);
    const documentHashWithVariables = concatenateQueryHashWithVariablesHash(documentHash, variables);
    return {
        documentHash,
        documentHashWithVariables
    };
}
export function concatenateQueryHashWithVariablesHash(documentHash, variables) {
    const stableStringifiedVariables = stableStringify(variables || {});
    return `${documentHash}#${stableStringifiedVariables}`;
}

//# sourceMappingURL=queryAndVariablesHashing.js.map